import { render } from "./list.vue?vue&type=template&id=6b3cd0c6&scoped=true"
import script from "./list.vue?vue&type=script&lang=js"
export * from "./list.vue?vue&type=script&lang=js"

import "./list.vue?vue&type=style&index=0&id=6b3cd0c6&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-6b3cd0c6"

export default script